import React, { useEffect, useRef, useState } from "react";

const FieldTooltip = ({ content, fieldId, label = "More information" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const tooltipRef = useRef(null);
  const tooltipId = `${fieldId}-tooltip`;

  useEffect(() => {
    if (!isOpen) return undefined;

    const closeTooltip = (event) => {
      if (event.key === "Escape" || (event.type === "mousedown" && tooltipRef.current && !tooltipRef.current.contains(event.target))) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", closeTooltip);
    document.addEventListener("keydown", closeTooltip);
    return () => {
      document.removeEventListener("mousedown", closeTooltip);
      document.removeEventListener("keydown", closeTooltip);
    };
  }, [isOpen]);

  if (!content) return null;

  return (
    <span className="estate-mapping__field-tooltip" ref={tooltipRef}>
      <button
        aria-controls={tooltipId}
        aria-expanded={isOpen}
        aria-label={label}
        className="estate-mapping__field-tooltip-trigger"
        onClick={() => setIsOpen((open) => !open)}
        type="button"
      >
        i
      </button>
      {isOpen && <span className="estate-mapping__field-tooltip-content" id={tooltipId} role="tooltip">{content}</span>}
    </span>
  );
};

export default FieldTooltip;
